import { Component, effect, OnInit } from '@angular/core';
import { DialogService } from '@shared/services/dialog.service';
import { GuardService } from '@shared/services/guard.service';
import { Title } from '@angular/platform-browser';
import { ContactService, UserService } from '@shared/services';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '@app/auth/services/auth.service';
import { environment } from '../environments/default/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
    constructor(
        private dialogService: DialogService,
        private authService: AuthService,
        private guardService: GuardService,
        titleService: Title,
        private contactService: ContactService,
        private translateService: TranslateService,
        private userService: UserService
    ) {
        titleService.setTitle(environment.projectTitle);
        effect(() => {
            if (!this.authService.isAuthenticated() && !this.guardService.isActive) {
                void this.showNoAccessDialog();
            }
        });
    }

    public async ngOnInit(): Promise<void> {
        this.checkAccess();

        if (!this.guardService.currentUser) {
            const user = await this.userService.getMyUser();
            this.guardService.currentUser = user;
        }
    }

    private checkAccess(): void {
        if (!this.authService.isAuthenticated() && !this.guardService.isActive) {
            void this.showNoAccessDialog();
        }
    }

    private async showNoAccessDialog(): Promise<void> {
        const contactPerson = await this.contactService.getContactPersonInfo();
        this.dialogService.openDialog(
            {
                header: 'dialog.main.noAccessHeader',
                message: this.translateService.instant('dialog.main.noAccessText', {
                    fullName: contactPerson.fullName,
                    eMail: contactPerson.eMail,
                    department: contactPerson.department,
                    company: contactPerson.company
                }),
                hideAllButtons: true,
                undraggable: true
            },
            {
                disableClose: true
            }
        );
    }
}

export function polarToCartesian(centerX, centerY, radius, angleInDegrees): { x: number; y: number } {
    const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;

    return {
        x: centerX + radius * Math.cos(angleInRadians),
        y: centerY + radius * Math.sin(angleInRadians)
    };
}

export function describeArc(x, y, radius, startAngle, endAngle): string {
    const start = polarToCartesian(x, y, radius, endAngle);
    const end = polarToCartesian(x, y, radius, startAngle);
    const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';

    return ['M', start.x, start.y, 'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y].join(' ');
}
